import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { flushPendingOrders } from "../ducks/shoppingCartSlice";
import ShopHeader from "../containers/ShopHeader";
import GroupedProductsView from "../containers/GroupedProductsView";
import GroupedProductsViewInstagram from "../containers/GroupedProductsViewInstagram";
import ShopFooter from "../containers/ShopFooter";
import FloatingCartSummary from "../containers/FloatingCartSummary";
import BasicSearch from "../containers/BasicSearch";
import TableConfirmationModal from "../containers/TableConfirmationModal";
import StatusButton from "../components/StatusButton";
import ReorderCard from "../containers/ReorderCard";
import ProductsHighlights from "../containers/ProductsHighlights";
import useMPSecurity from "../hooks/useMPSecurity";
import useScrollMemory from "../hooks/useScrollMemory";
import GroupedProductsTotemView from "../containers/GroupedProductsTotemView";
import { selectLayout } from "../ducks/shopSelectors";
import useCartSummary from "../hooks/useCartSummary";

export default function ShopHomeScreen() {
  const dispatch = useDispatch();
  const {
    tableId,
    isAvailableToOrder,
    layoutGroupsFirst,
    mercadoPagoKey,
    isSelfcheckout,
  } = useSelector((state) => state.shop);
  const layout = useSelector(selectLayout);
  const searchContent = useSelector((state) => state.search.content);
  const isSearching = !!searchContent && searchContent.length > 3;
  useMPSecurity(mercadoPagoKey, "home");
  // a home volta para onde o cliente estava ao sair (produto, sacola)
  useScrollMemory();

  const { isVisible: isCartVisible } = useCartSummary();

  React.useEffect(() => {
    const safetyDelay = setTimeout(() => {
      dispatch(flushPendingOrders());
    }, 3000);
    return () => clearTimeout(safetyDelay);
  }, [dispatch]);

  if (layout.home === "totem") {
    return <GroupedProductsTotemView isCartVisible={isCartVisible} />;
  }

  if (layout.home === "pos") {
    return (
      <>
        <div
          className={`shop-home-screen--${
            isCartVisible ? "stretched" : "normal"
          }`}
        >
          <GroupedProductsViewInstagram />
        </div>
        {isCartVisible && <FloatingCartSummary />}
      </>
    );
  }

  return (
    <>
      <div
        className={`shop-home-screen--${
          isCartVisible ? "stretched" : "normal"
        }`}
      >
        <StatusButton />
        <ShopHeader />
        <ReorderCard />
        <BasicSearch />
        <ProductsHighlights />
        {/* Layout de grupos da loja: grupos em sanfona. Buscando, a lista
            completa, que mostra os resultados sem precisar abrir grupo. */}
        {layoutGroupsFirst && !isSearching ? (
          <GroupedProductsViewInstagram showGroupMenu={false} />
        ) : (
          <GroupedProductsView />
        )}
        <ShopFooter />
      </div>
      {isCartVisible && <FloatingCartSummary />}
      {isAvailableToOrder && tableId && !isSelfcheckout ? (
        <TableConfirmationModal tableId={tableId} />
      ) : null}
    </>
  );
}
